import $ from 'jquery';

let SiteHeader = {
    initialised: false
};

/**
 * Add event listeners
 */
SiteHeader.init = function () {

    if (this.initialised) {
        return;
    }

    this.$el = $('#navbar');
    this.$subnav = this.$el.find('.subnav').eq(0);
    this.$mobileSubnav = this.$el.find('.mobile-subnav').eq(0);

    this.subnavActive = false;
    this.childSubnavActive = false;
    this.subnavHiding = false;
    this.currentSelector = null;
    this.currentChildSubnav = null;


    /** Desktop Event Handlers */

    this.$el.on('mouseenter', '[data-subnav]', function (e) {
        if (!$(e.target).is("a"))
            return;
        this.showDesktopSubnav($(e.currentTarget).data('subnav'));
    }.bind(this));

    this.$el.on('mouseleave', function (e) {
        this.hideDesktopSubnav();
    }.bind(this));

    this.$el.on('show.bs.collapse', '.navbar-collapse', function (e) {
        if ($(e.target).hasClass('navbar-collapse')) {
            $('html').addClass('navbar-open');
        }
    }.bind(this));

    this.$el.on('hide.bs.collapse', '.navbar-collapse', function (e) {
        if ($(e.target).hasClass('navbar-collapse')) {
            $('html').removeClass('navbar-open');
        }
    });

    $(document).on('click', '[data-action="openNav"]', function (e) {
        if ( e.target.dataset.page && e.target.dataset.page.length > 0 ) {
            const subnavItem = document.querySelector( '.mobile-subnav a[href="' + e.target.dataset.page +'"]' );

            if ( !subnavItem ) {
                return;
            }

            const parentMenu = subnavItem.closest( '.mobile-subnav .nav' );

            if ( !parentMenu ) {
                return;
            }

            this.$el.find('#mobileRoot').addClass('inactive');
            this.$mobileSubnav.addClass('active');
            $(parentMenu).parents().find('.nav.active').removeClass('active');
            $(parentMenu).addClass('active');
            this.currentChildSubnav = $(parentMenu);
            this.$el.collapse('show');
            return;
        }
        
        this.$el.collapse('show');
    }.bind(this));

    this.$el.on('click', '[data-child]', function (e) {
        e.preventDefault();
        this.openDesktopChildSubnav($(e.target));
    }.bind(this));

    this.$el.on('click', '[data-action="back"]', function (e) {
        e.preventDefault();
        this.closeDesktopChildSubnav($(e.target));
    }.bind(this));

    /** Mobile Event Handlers */

    this.$el.on('click', '[data-mobile-subnav]', function (e) {
        e.preventDefault();
        this.openMobileChildSubnav($(e.target));
    }.bind(this));

    this.$el.on('click', '[data-mobile-parent]', function (e) {
        e.preventDefault();
        this.closeMobileChildSubnav($(e.target));
    }.bind(this));

    /** final initialisation */

    this.initialised = true;
};

/** Mobile Nav Functions */

SiteHeader.openMobileChildSubnav = function ($target) {

    let target = $($target.data('mobile-subnav'));

    if (this.currentChildSubnav === target) {
        return;
    }

    this.$el.find('#mobileRoot').addClass('inactive');
    this.$mobileSubnav.addClass('active');

    $target.parents().find('.nav.active').removeClass('active');
    target.addClass('active');


    this.currentChildSubnav = target;

};

SiteHeader.closeMobileChildSubnav = function ($target) {

    let target = $($target.data('mobile-parent'));

    if ($target.data('mobile-parent') === '#mobileRoot') {

        this.$mobileSubnav.removeClass('active');
        this.$mobileSubnav.find('.nav').removeClass('active');
        this.$el.find('#mobileRoot').removeClass('inactive');

        this.currentChildSubnav = null;
        return;
    }

    if (this.currentChildSubnav === target) {
        return;
    }

    this.$mobileSubnav.find('.nav').removeClass('active');
    target.addClass('active');

    this.currentChildSubnav = target;
};

/** Desktop Nav Functions */

SiteHeader.openDesktopChildSubnav = function ($target) {

    let target = $($target.data('child'));

    if (!this.childSubnavActive) {
        this.showSubnavTimeout = setTimeout(function () {
            this.$subnav.find('.nav').removeClass('active');
            target.addClass('active');
        }.bind(this), 100);
    }

    if (target === this.currentChildSubnav) {
        return;
    }

    this.currentChildSubnav = target;
};

SiteHeader.closeDesktopChildSubnav = function ($target) {

    let target = $($target.data('parent'));

    if (!this.childSubnavActive) {
        this.hideSubnavTimeout = setTimeout(function () {
            this.$subnav.find('.nav').removeClass('active');
            target.addClass('active');
        }.bind(this),100);
    }

    if (target === '#desktopRoot') {
        this.currentChildSubnav = null;
        return;
    }

    this.currentChildSubnav = target;
};

SiteHeader.showDesktopSubnav = function (selector) {
    clearTimeout(this.hideTimeout);
    this.subnavHiding = false;

    if (!this.subnavActive) {
        this.$subnav.removeClass('in');
        this.$subnav.addClass('active');
        document.body.classList.add('nav-open');

        this.showTimeout = setTimeout(function () {
            this.$subnav.addClass('in');
        }.bind(this), 1);
        this.subnavActive = true;

        $(document).on('mousemove.subnav', function (e) {
            let $el = $(e.target);
            if (!($el.hasClass('subnav') || !!$el.data('subnav') || $el.parents('.subnav').length > 0 || $el.parents('[data-subnav]').length > 0)) {
                this.hideDesktopSubnav();
            } else {
                clearTimeout(this.hideTimeout);
                this.subnavHiding = false;
            }
        }.bind(this));
    }

    if (selector === this.currentSelector) {
        return;
    }

    this.currentSelector = selector;
    this.toggleSubnavTimeout = setTimeout(function () {
        this.$subnav.find('.nav').removeClass('active').filter(selector).addClass('active');
        this.$el.find( 'a[data-subnav]').removeClass('active');
        this.$el.find( 'a[data-subnav="' + selector + '"]').addClass('active');
    }.bind(this), 100);
};

SiteHeader.hideDesktopSubnav = function () {
    if (!this.subnavActive || this.subnavHiding) {
        return;
    }

    this.subnavHiding = true;
    this.childSubnavActive = false;

    clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(function () {

        if (!this.subnavActive) {
            return;
        }

        this.subnavActive = this.subnavHiding = false;
        $(document).off('mousemove.subnav');

        this.$subnav.removeClass('in');
        document.body.classList.remove('nav-open');
        this.$el.find( 'a[data-subnav]').removeClass('active');

        this.hideTimeout = setTimeout(function () {
            this.$subnav.removeClass('active');
        }.bind(this), 300);

    }.bind(this), 200);
};

export default SiteHeader;